// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./css/partials/_commons.scss
// module id = 80
// module chunks = 0